'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Section = require('./Section');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Section).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }